<template>
  <div id="payment-page">
    <div class='container'>
      <!-- Button trigger modal -->
      <button type="button" class="btn"
              :style="{ background: button_color, color: button_text_color }"
              @click="showModal">
        {{ button_title }}
      </button>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel" v-if="title">{{ title }}</h5>
              <h5 class="modal-title" id="exampleModalLabel" v-else>Gattioni payment</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Display have any error -->
              <div v-if='propsError'>
                <div v-for='error in errors' :key='error' class='text-danger'>{{ error }}</div>
              </div>

              <!-- Display Payment Methods if dont have error -->
              <div v-else>
                <div v-if='!showBank' class="methodsResults mt-3">
                  <a
                      v-for='bank in methods'
                      :key='bank.id'
                      @click='functionToShow(bank)'
                      class="col btn btn-info m-2 monetawebMethod">{{ bank.code.replace('_',' ').toUpperCase() }}</a>
                </div>

                <!-- Display vue component for bank selected -->
                <div v-if='showBank == "MONETAWEB" || showBank == "MYBANK"'>
                  <myBank :submitForm='submit' :data='data' :token='token' :merchant_id="merchant_id" :return_url='return_url' :language='language' :bank='showBank' :amount='amount'></myBank>
                </div>
                <div v-if='showBank == "PAYPAL"'>
                  <paypal :submitForm='submit' :data='data' :token='token' :return_url='return_url' :bank='showBank' :amount='amount'></paypal>
                </div>
                <div v-if='showBank == "SOFORT"'>
                  <sofort :submitForm='submit' :data='data' :token='token' :return_url="return_url" :bank='showBank' :amount='amount'></sofort>
                </div>
                <div v-if='showBank == "STRIPE"'>
                  <stripe :submitForm='submit' :data='data' :token='token' :return_url="return_url" :bank='showBank' :amount='amount' :name='name_stipe' :language='language'></stripe>
                </div>
                <div v-if='showBank == "FIDO_BORSELLINO"'>
                  <fidoBorsellino :fidoReservationType='reservationType' :submitForm='submit' :data='data' :token='token' :operationa_unit='operationa_unit' :bank='showBank' :amount='amount' :name='name_stipe' :language='language'></fidoBorsellino>
                </div>

                <div v-if='showBank'>
                  <a href="#" class="btn btn-secondary m-2 float-right"
                     @click='goBack'>Go back</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import myBank from '../components/MyBank'
import paypal from '../components/Paypal'
import sofort from '../components/Sofort'
import stripe from '../components/Stripe'
import fidoBorsellino from '../components/FidoBorsellino'

export default {
  name: 'PaymentPage',
  components: {
    myBank, paypal, stripe, sofort, fidoBorsellino
  },
  data: function() {
    return {
      methods: [],
      showBank: '',
      propsError: false,
      errors: [],
      submit: false,
      reservationType: '',
    };
  },
  props:{
    operationa_unit: String,
    merchant_id: {
      type: String
    },
    return_url: String,
    language: String,
    name_stipe: String,
    title: String,
    amount:{
      type: String,
      required: true
    },
    button_title: {
      type: String,
      default: 'Pay'
    },
    button_color: String,
    button_text_color: String,
    token: String,
    data: String,
    reservation_type: [String, Number]
  },
  created(){
    if (this.$props.reservation_type) {
      this.reservationType = this.$props.reservation_type;
    } else {
      this.reservationType = '74H';
    }

    // return error if is any error in prop
    if (!this.$props.amount) {
      this.errors.push('Amount prop Is required')
      this.propsError = true
    }
    if( isNaN(this.$props.amount) ){
      this.errors.push('Amount prop need to be number in format 5.99 or 10')
      this.propsError = true
    }
    if( this.$props.amount.toString().split('.')[1] ){
      if( this.$props.amount.toString().split('.')[1].length > 2 ){
        this.errors.push('Amount prop need to be number in format 5.99 or 10')
        this.propsError = true
      }
    }

    this.getmethods()
  },
  methods: {
    functionToShow: function (bank) {
      this.showBank = bank.code.toUpperCase();

      let self = this;

      if (bank.code == 'no_payment') {
        axios.post('https://gtn-gateway.draft2017.com/api/v1/orders',{
              amount: 0,
              method: 'no_payment',
              return_url: this.$props.return_url
            },
            {
              headers: {'Authorization': 'Bearer ' + this.$props.token}
            },
        )
            .then(response => {
                  console.log(response);
                  alert('Success');
                  this.showBank = '';
                }
            )
            .catch(function (error) {
              console.log(error);
              alert('Error');
              self.showBank = '';
            });
      }
    },
    showModal() {
      // Ensure jQuery is available now
      if (!window.jQuery) {
        console.error('jQuery is still not available');
        return;
      }

      try {
        this.methodFromData(true);
        window.jQuery('#exampleModal').modal('show');
      } catch (error) {
        console.error('Error showing modal:', error);
      }
    },
    goBack: function() {
      this.showBank = '';
    },
    getmethods: function() {
      if(this.$props.token) {
        var self = this;

        axios.post('https://gtn-gateway.draft2017.com/api/v2/methods',{
              amount: this.$props.amount,
              operationaUnit: this.$props.operationa_unit
            },
            {
              headers: {'Authorization': 'Bearer ' + this.$props.token}
            },
        )
            .then(response => {
              this.methods = response.data.methods;

              // if user added prop data than do this.
              if (this.$props.data) {
                this.methodFromData();
              }
            })
            .catch(function (error) {
              // handle error
              self.errors.push('Something went wrong');
              console.error(error);
              self.propsError = true;
            });
      } else {
        this.errors.push('Something went wrong.')
        console.log('Token error.')
        this.propsError = true
      }
    },
    methodFromData: function(submit=false) {
      try {
        if (!this.$props.data) {
          console.error('Data prop is missing or empty');
          return;
        }

        let object = JSON.parse(this.$props.data);
        if (object.method) {
          let num = 0;
          this.methods.forEach((bank) => {
            if (bank.code == object.method) {
              num = 1;
              this.showBank = bank.code.toUpperCase();
              this.submit = submit;
            }
          });

          if (!num) {
            console.error('You dont have access in this method.');
          }
        } else {
          console.error('Method field is required in data prop.');
        }
      } catch (error) {
        console.error('JSON parsing error:', error);
        // Still allow the modal to open even if there's an error
      }
    }
  }
}
</script>

<style>
#payment-page {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.methodsResults {
  color: #fff;
  font-weight: bold;
}
.monetawebMethod {
  font-weight: bold !important;
}
</style>